export default __webpack_public_path__ + "locales/ro/InviteDialog.json?hash=432a161cb301686b6ef48abeeb9c5879";